import classes from "./styles.module.scss";
import { FadeIn } from "@/ui/FadeIn";
import * as components from "./components";

/**
 * Sections that can fall inside the initial viewport. They fade from CSS rather than
 * waiting on hydration, because an above-the-fold section held at `opacity: 0` is not a
 * Largest Contentful Paint candidate until React mounts.
 */
const SECTIONS_VISIBLE_ON_LOAD = 2;

/**
 *
 * @param items
 * @param allowedComponents
 * @returns {JSX.Element}
 * @constructor
 */
export const Content = ({ items, additionalComponents }) => {
  const allowedComponents = {
    ...components,
    ...additionalComponents,
  };

  return (
    <div className={classes.content}>
      {items.map(({ component, id, props }, k) => (
        <FadeIn from="bottom" delayInMilliseconds={150} immediate={k < SECTIONS_VISIBLE_ON_LOAD} key={k}>
          {id && <a id={id} />}
          {(() => {
            if (typeof component !== "undefined" && component in allowedComponents) {
              const Component = allowedComponents[component];

              return <Component {...props} />;
            }
          })()}
        </FadeIn>
      ))}
    </div>
  );
};

Content.defaultProps = {
  items: [],
  additionalComponents: {},
};
